export function buildWeightedScoresPageQueryV1(workspaceId: number, projectId: number, evalModelId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.WeightedScores.Queries.WeightedScoresPageQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
	}
}



export function buildBlankWeightedScoreSettingsQueryV1(workspaceId: number, projectId: number, evalModelId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.WeightedScores.Queries.BlankWeightedScoreSettingsQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
	}
}
export function buildWeightedScoreSettingsByIdQueryV1(workspaceId: number, projectId: number, evalModelId: number, weightedScoreId: string)
{
	return {
		'$type': 'TCh.Domain.Criteria.WeightedScores.Queries.WeightedScoreSettingsByIdQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'WeightedScoreId': weightedScoreId,
	}
}
export function buildWeightedScoreSettingsByAttributeIdQueryV1(workspaceId: number, projectId: number, attributeId: number)
{
	return {
		'$type': 'TCh.Domain.Criteria.WeightedScores.Queries.WeightedScoreSettingsByAttributeIdQueryV1, TCh.Domain.Criteria',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AttributeId': attributeId,
	}
}